import { render, staticRenderFns } from "./ViewParticipantsPage.vue?vue&type=template&id=5f5866bc&scoped=true&"
import script from "./ViewParticipantsPage.vue?vue&type=script&lang=js&"
export * from "./ViewParticipantsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5866bc",
  null
  
)

export default component.exports